export class PollingStatus {
    public static readonly OK = 'Ok';
    public static readonly UNSTABLE = 'Unstable';
    public static readonly DISCONNECTED = 'Disconnected';
    public static readonly PAUSED = 'Paused';
    public static readonly FIXED_DATE = 'Fixed Date';
    public static readonly MAX_ERRORS_ALLOWED = 5;
}
